import AppointmentList from '@/views/appointment/List.vue'
import AppointmentSingle from '@/views/appointment/Single.vue'
import AppointmentCreate from '@/views/appointment/Create.vue'
import AppointmentUpdate from '@/views/appointment/Update.vue'
import AppointmentCancel from '@/views/appointment/Cancel.vue'
import AppointmentSearch from '@/views/appointment/Search.vue'

export default [
  {
    path: '/al',
    name: 'appointment-list',
    component: AppointmentList,
    meta: {
      auth: 'all',
      breadcrumbs: [
        {
          link: 'appointment-list',
          title: 'Appointment List'
        }
      ]
    }
  },
  {
    path: '/as/:id',
    name: 'appointment-single',
    component: AppointmentSingle,
    meta: {
      auth: 'all',
      breadcrumbs: [
        {
          link: 'appointment-list',
          title: 'Appointment List'
        },
        {
          link: 'appointment-single',
          title: 'Single Appointment',
          params: 'id'
        }
      ]
    }
  },
  {
    path: '/ac/:dentist?',
    name: 'appointment-create',
    component: AppointmentCreate,
    meta: {
      auth: ['operator'],
      breadcrumbs: [
        {
          link: 'appointment-create',
          title: 'Create Appointment'
        }
      ]
    }
  },
  {
    path: '/au/:id',
    name: 'appointment-update',
    component: AppointmentUpdate,
    meta: {
      auth: ['operator'],
      breadcrumbs: [
        {
          link: 'appointment-list',
          title: 'Appointment List'
        },
        {
          link: 'appointment-single',
          title: 'Single Appointment',
          params: 'id'
        },
        {
          link: 'appointment-update',
          title: 'Update Appointment',
          params: 'id'
        }
      ]
    }
  },
  {
    path: '/ad/:id', // ad - Appointment Delete - to prevent clashing with Appointment Create
    name: 'appointment-cancel',
    component: AppointmentCancel,
    meta: {
      auth: ['operator'],
      breadcrumbs: [
        {
          link: 'appointment-list',
          title: 'Appointment List'
        },
        {
          link: 'appointment-single',
          title: 'Single Appointment',
          params: 'id'
        },
        {
          link: 'appointment-cancel',
          title: 'Cancel Appointment',
          params: 'id'
        }
      ]
    }
  },
  {
    path: '/aq', // aq - Appointment Query - to prevent clashing with Appointment Single
    name: 'appointment-search',
    component: AppointmentSearch,
    meta: {
      auth: 'all',
      breadcrumbs: [
        {
          link: 'appointment-list',
          title: 'Appointment List'
        },
        {
          link: 'appointment-search',
          title: 'Appointment Search'
        }
      ]
    }
  }
]
